package com.tovtalk.ui.platform

import kotlinx.browser.document
import org.w3c.dom.HTMLVideoElement

private const val REEL_CONTAINER_ID = "tovtalk-reel-container"

actual fun setReelContainerVisible(visible: Boolean) {
    val container = document.getElementById(REEL_CONTAINER_ID) as? org.w3c.dom.HTMLElement ?: return
    container.style.display = if (visible) "block" else "none"
    // Pause the shared video when hidden — otherwise audio keeps playing on Settings/Profile/etc.
    // The Composable that owns this video is disposed on navigation but the DOM element persists.
    if (!visible) {
        (container.querySelector("video") as? HTMLVideoElement)?.pause()
    }
}
